var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"cookieModal",domProps:{"innerHTML":_vm._s(_vm.$t('cookies.modal.content', {client: _vm.clientName, site: _vm.productionUrl}))}})])
}
var staticRenderFns = []

export { render, staticRenderFns }